import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@akinon/next/components/client-root.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@akinon/next/components/pz-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebVitals"] */ "/app/node_modules/@akinon/next/components/web-vitals.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@akinon/next/utils/get-currency.ts");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/[commerce]/[locale]/[currency]/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../../../../assets/fonts/Satoshi/Satoshi-Variable.ttf\",\"variable\":\"--font-satoshi\",\"display\":\"swap\"}],\"variableName\":\"satoshiFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[commerce]/[locale]/[currency]/client-root.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PersonaClickLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PersonaProfileWatcher.tsx");
